import { render, staticRenderFns } from "./PageRefBlock.vue?vue&type=template&id=4ab9b85a&scoped=true&"
import script from "./PageRefBlock.vue?vue&type=script&lang=ts&"
export * from "./PageRefBlock.vue?vue&type=script&lang=ts&"
import style0 from "./PageRefBlock.vue?vue&type=style&index=0&id=4ab9b85a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab9b85a",
  null
  
)

export default component.exports